import { Mask, Text, View, Heading, IconWarningSolid, Button } from '@smarterservices/smarter-ui';
import {
    updateNavigation,
    replacePathPlaceholders,
} from '../../helpers/utilities';
import { ROUTES } from '../../config';

function AlreadyInRoomOverlay() {

    return (
        <Mask placement="center" fullscreen={true}
            themeOverride={{
                zIndex: 9999,
                background: 'rgba(255, 255, 255, 1)'
            }}>
            <View
                as="div"
                padding="large"
                textAlign="center"
                display="flex"
                margin="auto none"
                style={{
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: '#f5f5f5'
                }}
            >
                <View
                    as="div"
                    maxWidth="600px"
                    background="primary"
                    padding="large"
                    borderRadius="medium"
                    borderColor="primary"
                    borderWidth="small"
                    shadow="resting"
                    margin="none auto"
                >
                    <View as="div" margin="none none large none">
                        <IconWarningSolid size="large" color="warning" />
                    </View>
                    <Heading level="h3" margin="none none medium none">
                        You are already in this room in another location.
                    </Heading>
                    <Text as="p" margin="none none medium none">
                        Logout of all other sessions and try again.
                    </Text>
                    <Button
                        margin="medium none none none"
                        color="primary"
                        onClick={() => updateNavigation(replacePathPlaceholders(ROUTES.ROOMS))}
                    >
                        View Room List
                    </Button>
                </View>
            </View>


        </Mask >
    );
}

export default AlreadyInRoomOverlay;
